import cookie from 'js-cookie'

import { selectGenderPath } from 'components/page/Onboarding/paths'
import { indexPath } from 'components/paths'

import { startWithLoginCookie } from '../cookies'

export const searchAuthorizationPath = (authorizedBefore: boolean) => {
  return authorizedBefore ? indexPath : selectGenderPath
}

export const clientFindAuthorizationPath = () => {
  const authorizedBefore = Boolean(cookie.get(startWithLoginCookie))
  return searchAuthorizationPath(authorizedBefore!)
}

export const serverFindAuthorizationPath = (cookies) => {
  const authorizedBefore = Boolean(cookies[startWithLoginCookie])
  return searchAuthorizationPath(authorizedBefore)
}
